// External modules
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { DateOfBirth as DateOfBirthInput } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

const DateOfBirth = props => {
  useMountLogging('DateOfBirth');
  const dateOfBirth = useStoreState(({ form }) => form.dateOfBirth);
  const { displayFormat, datePattern } = useStoreState(({ api }) => {
    return api.griffinMetadata.dateMeta;
  });

  return (
    <DateOfBirthInput
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      dateFormat={displayFormat}
      datePattern={datePattern}
      focusHandler={props.focusHandler}
      id="dateOfBirth"
      label={getContent('fieldLabels.dob')}
      required={true}
      type="tel"
      {...dateOfBirth}
    />
  );
};

DateOfBirth.propTypes = {
  blurHandler: func.isRequired,
  changeHandler: func.isRequired,
  focusHandler: func.isRequired,
};

export { DateOfBirth };
